module.exports = __webpack_public_path__ + "img/IMG_0374_L_BlackMatted.41b71030.jpg";